// extracted by mini-css-extract-plugin
export default {"lds-ring":"Loader_lds-ring__HhVVi"};